import React, { useState, useEffect } from "react";

export default function WhackAMole() {
  const [score, setScore] = useState(0);
  const [moleIdx, setMoleIdx] = useState(null);
  const [timeLeft, setTimeLeft] = useState(0);

  useEffect(() => {
    if (timeLeft > 0) {
      const timer = setTimeout(() => setTimeLeft(timeLeft - 1), 1000);
      const mover = setTimeout(
        () => setMoleIdx(Math.floor(Math.random() * 9)),
        600,
      );
      return () => {
        clearTimeout(timer);
        clearTimeout(mover);
      };
    } else {
      setMoleIdx(null);
    }
  }, [timeLeft, moleIdx]);

  const whack = (i) => {
    if (i === moleIdx && timeLeft > 0) {
      setScore((s) => s + 1);
      setMoleIdx(null);
    }
  };

  return (
    <div className="min-h-screen bg-slate-900 flex flex-col items-center justify-center text-white">
      <h1 className="text-4xl font-bold mb-4">Whack-a-Mole</h1>
      <div className="flex gap-8 mb-8 text-xl font-semibold">
        <p>
          Score: <span className="text-green-400">{score}</span>
        </p>
        <p>
          Time: <span className="text-red-400">{timeLeft}s</span>
        </p>
      </div>

      <div className="grid grid-cols-3 gap-3 bg-green-800 p-4 rounded-2xl">
        {Array.from({ length: 9 }).map((_, i) => (
          <div
            key={i}
            onClick={() => whack(i)}
            className="w-20 h-20 sm:w-28 sm:h-28 bg-green-900 rounded-full flex items-center justify-center overflow-hidden cursor-pointer relative border-4 border-green-950"
          >
            {moleIdx === i && (
              <div className="text-5xl sm:text-6xl animate-bounce absolute bottom-0">
                🦫
              </div>
            )}
          </div>
        ))}
      </div>

      {timeLeft === 0 && (
        <button
          onClick={() => {
            setScore(0);
            setTimeLeft(30);
          }}
          className="mt-8 px-8 py-3 bg-indigo-600 rounded-xl font-bold hover:bg-indigo-700"
        >
          Start Game (30s)
        </button>
      )}
    </div>
  );
}
